import React, {memo, useCallback, useMemo} from 'react';
import PropTypes from 'prop-types';
import {Tag} from 'antd';
import {map} from 'lodash';
import {TermFilter} from '@dofleini/query-builder';
import ClientsApiService from '@/modules/clients/services/ClientsApiService';
import {useGetAllStructures} from '@/modules/clients/hooks/useClients';
import SelectElementCmpOld from '@/utils/SelectElementCmpOld';

// eslint-disable-next-line no-unused-vars
const SelectUserStructures = ({value, onChange, setClients, clients, translation, setClientsValues, user, ...props}) => {

  const currentValue = useMemo(() => {
    return Array.isArray(value) ? value.map(v => v?._id || v) : undefined;
  }, [value]);
  
  const handleOnChange = useCallback((value) => {
    setClientsValues(value);
    onChange(value);
  }, [onChange, setClientsValues]);

  const setEntities = useCallback((entities) => {
    if ((!clients || clients.length === 0) && entities?.length > 0) {
      setClients(entities);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SelectElementCmpOld
      queryKey={'user-structures'}
      service={ClientsApiService}
      customMethod="/ms-core/api/structures/search-for-client-users"
      includeValue={''}
      value={currentValue}
      onChange={handleOnChange}
      sort={{ code: 1 }}
      queryConfig={{ refetchOnWindowFocus: false }}
      className="custom-select"
      placeholder={!user ? translation('placeholderSelectServices'): '-'}
      nameToShow={'name'}
      mode={'multiple'}
      afterLoadData={setEntities}
      additionalParams={{
        forceSize: true,
        size: 1000,
        useProjections: true,
        projections: {
          name: 1,
          servicesTemplatesGoal: 1,
        }
      }}
      {...props}
    />
  );
};

SelectUserStructures.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  filters: PropTypes.object,
  isViewMode: PropTypes.func,
  translation: PropTypes.func,
  setClients: PropTypes.func,
  clients: PropTypes.array,
  setClientsValues: PropTypes.func,
  user: PropTypes.string
};

// eslint-disable-next-line no-unused-vars
const SelectUserStructuresView = ({value, entity}) => {
  const filter = useMemo(() => {
    return new TermFilter({field: '_id', value: { $in: value } }).toQuery();
  }, [value]);
  
  const {data} = useGetAllStructures(filter);

  const tagsRender = useCallback((value) => {
    return (<div className='flex flex-wrap'>
      {map(value, (item) => (
        <div key={`tag-${item['_id']}`} className="pb-2">
          <Tag className="px-2 py-1">
            {item['name']}
          </Tag>
        </div>
      ))}
    </div>);
  }, []);

  return (
    <>
      {tagsRender(data|| [])}
    </>
  );
};

SelectUserStructuresView.propTypes = {
  value: PropTypes.string,
  entity: PropTypes.object,
};

export default memo(SelectUserStructures);

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {String} text this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {object} entity this is entity type
 * */
export const renderUserStructures = (text, entity) => {
  return (
    <SelectUserStructuresView value={text} entity={entity}/>
  );
};

